import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerContent,
} from "@/components/ui/drawer";

/**
 * Thin "shell" component that picks the right host based on viewport:
 *  - >= 640px: classic centered `Dialog` (shadcn)
 *  - < 640px : vaul-powered bottom-sheet `Drawer` with drag-to-dismiss
 *
 * Children render inside both shells. The component is otherwise transparent
 * (no built-in header or scroll container) so consumers keep full layout
 * control over their existing custom headers + body.
 */
export function ResponsiveDialog({
  open,
  onOpenChange,
  children,
  dialogClassName = "sm:max-w-[480px] p-0 overflow-hidden bg-white border-[#E5E1D8] rounded-3xl",
  drawerClassName = "bg-white border-[#E5E1D8] !h-auto max-h-[92dvh] p-0",
  testId,
}) {
  const [isMobile, setIsMobile] = useState(
    // Initialise synchronously so the right host renders on first paint —
    // avoids a flash of the centered Dialog before the effect flips to Drawer
    // on mobile when the consumer opens the modal on mount.
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia("(max-width: 639px)").matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
        <DrawerContent data-testid={testId} className={drawerClassName}>
          {children}
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testId} className={dialogClassName}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
